// dataService.js - Livreur Planning
import api from '../../utils/ApiConfig';

// Fetch all livreurs with their schedules
const fetchAllLivreurs = async () => {
  try {
    const response = await api.get('/users/role/3'); // role 3 = livreur
    return response.data;
  } catch (error) {
    console.error('Error fetching livreurs:', error);
    throw error;
  }
};

// Fetch one livreur schedule by ID
const fetchLivreurSchedule = async (livreurId) => {
  try {
    const response = await api.get(`/livreurs/${livreurId}/schedule`);
    return response.data;
  } catch (error) {
    console.error('Error fetching livreur schedule:', error);
    throw error;
  }
};

// Update livreur weekly schedule
const updateLivreurSchedule = async (livreurId, scheduleData) => {
  try {
    const response = await api.put(`/livreurs/${livreurId}/schedule`, scheduleData);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to update schedule. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error updating livreur schedule:', error);
    throw error;
  }
};

// Initialize default schedule for a new livreur
const initDefaultSchedule = async (livreurId) => {
  try {
    const response = await api.post(`/livreurs/${livreurId}/init-schedule`);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to init schedule. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error initializing schedule:', error);
    throw error;
  }
};

// Fetch time-off requests for a livreur
const fetchLivreurTimeOff = async (livreurId, filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);

    const response = await api.get(`/livreurs/${livreurId}/time-off?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching time-off:', error);
    throw error;
  }
};

// Create time-off request
const createTimeOff = async (livreurId, timeOffData) => {
  try {
    const response = await api.post(`/livreurs/${livreurId}/time-off`, timeOffData);
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Failed to create time-off. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error creating time-off:', error);
    throw error;
  }
};

// Update time-off status (approve/reject)
const updateTimeOffStatus = async (timeOffId, status) => {
  try {
    const response = await api.put(`/time-off/${timeOffId}/status`, { status });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to update time-off status. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error updating time-off status:', error);
    throw error;
  }
};

// Fetch livreur capacity settings
const fetchLivreurCapacity = async (livreurId) => {
  try {
    const response = await api.get(`/livreurs/${livreurId}/capacity`);
    return response.data;
  } catch (error) {
    console.error('Error fetching capacity:', error);
    throw error;
  }
};

// Update livreur capacity settings
const updateLivreurCapacity = async (livreurId, capacityData) => {
  try {
    const response = await api.put(`/livreurs/${livreurId}/capacity`, capacityData);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to update capacity. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error updating capacity:', error);
    throw error;
  }
};

// Fetch availability summary for a period
const fetchAvailabilitySummary = async (livreurId, from, to) => {
  try {
    const response = await api.get(`/livreurs/${livreurId}/availability-summary?from=${from}&to=${to}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching availability summary:', error);
    throw error;
  }
};

// Export methods
export {
  fetchAllLivreurs,
  fetchLivreurSchedule,
  updateLivreurSchedule,
  initDefaultSchedule,
  fetchLivreurTimeOff,
  createTimeOff,
  updateTimeOffStatus,
  fetchLivreurCapacity,
  updateLivreurCapacity,
  fetchAvailabilitySummary,
};
